module.exports = __webpack_public_path__ + "7ec5b306275b991b702da37d549915c5.svg";